<div class="container loader-container" *ngIf="model$ | async as model">
    <div class="columns">
        <div class="column">
            <div class="column-content">
                <h2>Build your feedback button</h2>
                <p>
                    Create a feedback button that feels native to your product. Customize, save and publish it
                    when you’re ready.
                </p>
                <form id="MainForm" #mainForm="ngForm" (ngSubmit)="submit(mainForm)" novalidate>

                    <div class="form-field">
                        <color-input label="Button foreground color"
                                     id="buttonForegroundColorId"
                                     name="buttonForegroundColor"
                                     [(ngModel)]="model.ButtonForegroundColor"
                                     (ngModelChange)="onChange()"
                                     required>
                        </color-input>
                    </div>
                    <div class="form-field">
                        <color-input label="Button background color"
                                     id="buttonBackgroundColorId"
                                     name="buttonBackgroundColor"
                                     [(ngModel)]="model.ButtonBackgroundColor"
                                     (ngModelChange)="onChange()"
                                     required>
                        </color-input>
                    </div>
                    <div class="form-field">
                        <label>Button icon</label>
                        <dropdown-component name="buttonIcon"
                                            [(selectedValue)]="model.ButtonIcon"
                                            [options]="icons"
                                            (selectedValueChange)="onChange()">
                        </dropdown-component>
                    </div>
                </form>
            </div>
            <div class="column-footer">
                <p>Want to start over? Click Reset to revert back to the default button.</p>
                <button type="button" class="btn" (click)="reset()">
                    <i class="fa fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="column preview__column">
            <div class="column-content">
                <iframe #previewFrame
                        class="preview__section"
                        sandbox="allow-scripts allow-same-origin allow-modals"
                        [srcdoc]="previewHtml">
                </iframe>
            </div>

            <div *ngIf="error$ | async as error" class="error-message-box">
                <i class="fa fa-exclamation-triangle"></i> {{ error }}
            </div>

            <div class="column-footer">
                <p>Satisfied with the results? Let's save your button.</p>
                <button type="submit" class="btn" form="MainForm">Save Button <i class="fa fa-arrow-right"></i></button>
            </div>
        </div>

    </div>

    <loader-component *ngIf="loading$ | async"></loader-component>
</div>
